export const customImagesSchema = {
  type: "object",
  properties: {
    name: { type: "string" },
    references: {
      type: "array",
      items: {
        type: "object",
        properties: {
          component: { type: "string" },
          images: {
            type: "array",
            items: {
              type: "object",
              properties: {
                name: { type: "string", "minLength": 1 },
                path: { type: "string", "minLength": 1 },
                version: { type: "string", "minLength": 1 }
              },
              required: ["name", "path", "version"]
            }
          },
          packages: {
            type: "array",
            items: {
              type: "object",
              properties: {
                name: { type: "string", "minLength": 1 },
                path: { type: "string", "minLength": 1 },
                version: { type: "string", "minLength": 1 }
              },
              required: ["name", "path", "version"]
            }
          }
        },
        required: ["component", "images", "packages"]
      }
    }
  },
  required: ["references"],
  additionalProperties: false
};